module.exports = __webpack_public_path__ + "img/voice-thumb1.9f39f27.jpg";